import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { IRGB } from '@picsart/web-layering/types';
import { ExpandStates } from '@picsart/editorlayout';

import batchSlice from 'store/batch';
import useMemoSelector from 'hooks/useMemoSelector';
import { getBatchActiveColor, getBatchActiveTexture } from 'store/batch/selectors';
import ColorPalette from 'components/common/ColorPalette';
import { IProcessingTool } from 'pages/Batch/sections/Sidebar/types';
import analytics, { SubToolNames } from 'pages/Batch/utils/analytics';
import { BATCH_TOOLS, TRANSPARENT_OPTION } from 'pages/Batch/configs';
import useBatchData from 'pages/Batch/sections/Context/useBatchData';

const RemoveBgColors = ({ inProgress }: IProcessingTool) => {
  const activeColor = useMemoSelector(getBatchActiveColor);
  const activeTexture = useMemoSelector(getBatchActiveTexture);
  const dispatch = useDispatch();
  const { isWeb, expandedState } = useBatchData();

  const resetActiveTexture = useCallback(() => dispatch(batchSlice.actions.setActiveTexture(null)), [dispatch]);

  const handlePresetColor = useCallback((color: IRGB) => {
    if (inProgress) return;
    dispatch(batchSlice.actions.setActiveColor(color));
    resetActiveTexture();
    analytics.utils().setSubTool(BATCH_TOOLS.removeBG, {
      name: SubToolNames.color,
      value: color ? `rgb(${color.r}, ${color.g}, ${color.b})` : TRANSPARENT_OPTION,
    }, SubToolNames.texture);
  }, [dispatch, inProgress, resetActiveTexture]);

  return (
    <ColorPalette isMultiRow={isWeb || expandedState === ExpandStates.Full} onColorSelect={handlePresetColor} activeColor={activeTexture ? undefined : activeColor} />
  );
};

export default memo(RemoveBgColors);
